import { DolaThemes } from '../../styles/types'
import { InputModes } from '.'
import { errorColor } from '../../styles/variables'

type Theme = Record<
  DolaThemes,
  Record<InputModes, Record<'background' | 'border' | 'label' | 'text', string>>
>

const inputTheme: Theme = {
  dark: {
    active: {
      background: '#101010',
      border: '#5432D3',
      label: '#FFFFFF',
      text: '#FFFFFF',
    },
    default: {
      background: '#101010',
      border: '#232323',
      label: '#FFFFFF',
      text: '#FFFFFF',
    },
    error: {
      background: '#101010',
      border: errorColor,
      label: errorColor,
      text: errorColor,
    },
  },
  light: {
    active: {
      background: '#FFFFFF',
      border: '#0B0B0B',
      label: '#0B0B0B',
      text: '#0B0B0B',
    },
    default: {
      background: '#FFFFFF',
      border: '#DDDDDD',
      label: 'RGBA(11, 11, 11, 40%)',
      text: '#0B0B0B',
    },
    error: {
      background: '#FFFFFF',
      border: errorColor,
      label: errorColor,
      text: errorColor,
    },
  },
}

export default inputTheme
